const ReportRoutes = [
    {
        name: 'SummaryReport',
        path: '/report/summary-report',
        component: () => import('@/views/Report/SummaryReport.vue'),
    },
    {
        name: 'SummaryLateReport',
        path: '/report/summary-late-report',
        component: () => import('@/views/Report/SummaryLateReportByDateRange.vue'),
    },
]
export default ReportRoutes
